/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AccessStatus {
	NoPermissions = 0,
	HasPermissions = 1,
	Deleted = -1,
}
